import Api from '../Api';

import { url } from './config';
import { ComponentType } from './types';

const api = new Api<ComponentType>(url);

export default api;
